import { Checkbox, Typography } from '@montugroup/design-system';
import FormControlLabel from '@mui/material/FormControlLabel';
import React from 'react';

interface ConsentCheckboxProps {
  text: string | React.ReactNode;
  trackingId: string;
  size?: 'small' | 'medium';
  checked: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  testid?: string;
}

export default function ConsentCheckbox({ text, size, checked, onChange, testid, trackingId }: ConsentCheckboxProps) {
  return (
    <FormControlLabel
      sx={{ display: 'flex', alignItems: 'flex-start', lineHeight: '1rem' }}
      control={
        <Checkbox
          sx={{ marginTop: '0rem', paddingTop: size === 'small' ? '0.25rem' : 0, paddingBottom: 0 }}
          size={size}
          checked={checked}
          onChange={onChange}
          data-testid={testid}
          data-tracking-id={`ConsentCheckbox_${trackingId}`}
        />
      }
      label={
        <Typography variant={size === 'small' ? 'caption' : 'body2'} sx={{ userSelect: 'none' }}>
          {text}
        </Typography>
      }
    />
  );
}
